import './Loader.scss';

//loader 
export default function Loader()
    {
        return (
            <div className="Loader" >
                <div className="Loader_title" ></div>
                <div className="Loader_title_reflet"></div> 
                <div className="Loader_txt"><div>Chargement</div></div>
            </div>
        )
    }